<script>
	export default {
		props: {
			block: Object
		},
		render () {
			if(this.block && this.block.body) {
				return <div domPropsInnerHTML={this.block.body} class="text-block"></div>
			} else {
				return <div class="text-block">{this.$slots.default}</div>
			}
		}
	}
</script>

<style lang="scss" scoped>

	@import "media";

	.text-block {

		padding:0 5vw;

		/deep/ {
			a {
				color:#FDB913; text-decoration:none;
				&:hover {
					text-decoration:underline;
				}
			}
			p {
				&:first-child {
					margin-top:0;
				}
				&:last-child {
					margin-bottom:0;
				}
			}
			strong {
				color:#3D3D3D; font-weight:600;
			}
			h2 {
				font-weight:400; color:#000; text-transform:uppercase;
				& + p {
					margin-top:.5rem;
				}
			}
			img {
				@include media(small, large) {
					width:100% !important; height:auto !important;
				}
			}
			.embed_media {
				@include media(small, large) {
					max-width:100%;
				}
				iframe {
					@include media(small, large) {
						width:100% !important; height:auto !important;
					}
				}
			}
		}

	}

</style>



// WEBPACK FOOTER //
// src/components/BlogBlockTypes/Text.vue